export default __webpack_public_path__ + "static/media/plotly-grayscale.fbc9e171.svg";